import React, {forwardRef} from 'react';
import {AppBar, MenuItemLink, useGetIdentity, useLogout, UserMenu} from 'react-admin';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import {makeStyles} from '@material-ui/core/styles';
import logo from './images/logo.png';
import {LinearProgress, MenuItem} from "@material-ui/core";
import SettingsIcon from "@material-ui/icons/Settings";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import {ProfileProvider, useProfile} from "./profile";

const useStyles = makeStyles({
    title: {
        flex: 1,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        marginLeft: -10,
        fontFamily: 'Arial',
    },
    spacer: {
        flex: 1,
    },
    logo: {
        maxWidth: "100px",
        marginLeft: -10,
        marginRight: 10,
    },
})

const CustomAppBar = (props) => {
    const classes = useStyles();
    const {identity, loading: identityLoading} = useGetIdentity();
    if (identityLoading) {
        return (
            <LinearProgress/>
        )
    }

    return (
        <ProfileProvider>
            <AppBar color='primary'>
                <Toolbar>
                    <img src={logo} alt="logo" className={classes.logo}/>
                </Toolbar>
                <Typography
                    variant="h6"
                    color="inherit"
                    className={classes.title}
                >
                </Typography>
                <Typography
                    variant="h6"
                    color="inherit"
                    className={classes.title}
                    id="react-admin-title"
                />
                <Toolbar>
                    <Typography className={classes.title}>
                        Bentornato, {identity.name}
                    </Typography>
                </Toolbar>
                <MyUserMenu/>
            </AppBar>
        </ProfileProvider>
    );
};

const MyUserMenu = (props) => {
    const {profileVersion} = useProfile();
    return (
        <UserMenu key={profileVersion} {...props}>
            <MenuItemLink
                to="/my-profile"
                primaryText="Il Mio Profilo"
                leftIcon={<SettingsIcon/>}
            />
            <MyLogoutButton/>
        </UserMenu>
    );
}

const MyLogoutButton = forwardRef((props, ref) => {
    const logout = useLogout();
    const handleClick = () => logout();
    return (
        <MenuItem
            onClick={handleClick}
            ref={ref}
        >
            <ExitToAppIcon style={{marginRight: "30%"}}/> Logout
        </MenuItem>
    );
});

export default CustomAppBar;